import styled from "styled-components";

export const FilterItemTitleBox = styled.span`
  margin-left: 2em;
  font-size: 1.5rem;
  ${({theme}) => theme.font.presets.medium};
  color: ${props => props.theme.colors.text};
`;